import "./instrument";

import { createRoot } from "react-dom/client";
import App from "./App";

import "./index.css";

const queryParams = new URLSearchParams(window.location.search);

const token = queryParams.get("token") || window.authToken;
const hasClose = queryParams.get("has_close");
const bypassPlaidAccountConfirmation = queryParams.get(
  "bypass_plaid_account_confirmation"
);
const withIntercom = queryParams.get("with_intercom");

createRoot(document.getElementById("root")!).render(
  <App
    token={token || ""}
    hasClose={Boolean(hasClose)}
    bypassPlaidAccountConfirmation={Boolean(bypassPlaidAccountConfirmation)}
    withIntercom={Boolean(withIntercom)}
  />
);
